module.exports = __webpack_public_path__ + "static/img/mechanism-2.99b2885a.png";